<template>
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="users"
      :search="search"
      :pagination.sync="pag"
    >
      <template v-slot:items="props">
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.email }}</td>
        <td>
          <v-icon
            left
            @click.stop="startUpdate(props.item.id, props.item.status)"
            :color="
              props.item.status === 'canceled' ||
              props.item.status === 'inativo'
                ? 'red'
                : 'green'
            "
          >
            {{
              props.item.status === "canceled" ||
              props.item.status === "inativo"
                ? "person_off"
                : "person"
            }}
          </v-icon>
          {{ props.item.status || "ATIVO" | formatUserStatus }}
        </td>
        <td>
          <div v-if="props.item.group && Array.isArray(props.item.group)">
            <v-chip
              v-for="(item, i) in props.item.group"
              :key="i"
              color="grey"
              text-color="white"
              >{{ item }}</v-chip
            >
          </div>
          <div v-else>
            <v-chip color="grey" text-color="white">{{
              props.item.group
            }}</v-chip>
          </div>
        </td>
        <td class="text-xs-right">
          <v-btn
            flat
            icon
            color="grey darken-1"
            @click="openUserForm('edit', props.item)"
            :disabled="loading"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </td>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog_modify_status_user" max-width="290" dark>
      <v-card color="red">
        <v-card-title class="headline"
          >Tem certeza que deseja
          {{ status !== "canceled" ? "ativar" : "cancelar" }} esse
          usuário?</v-card-title
        >

        <!-- <v-card-text>
          Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.
        </v-card-text> -->

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="black darken-1"
            @click="dialog_modify_status_user = false"
            dark
          >
            Não
          </v-btn>

          <v-btn
            color="black darken-1"
            dark
            @click="updateModifyStatusUser(customer_id, status)"
          >
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { eventBus } from "@/main";
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Nome",
          align: "left",
          sortable: false,
          value: "name",
        },
        { text: "E-mail", value: "email" },
        { text: "Status", value: "status" },
        { text: "Grupos", value: "group" },
        //   { text: 'Carbs (g)', value: 'carbs' },
        //   { text: 'Protein (g)', value: 'protein' },
        //   { text: 'Iron (%)', value: 'iron' }
      ],
      pag: {
        rowsPerPage: 50,
        // totalItems: 20
      },
      dialog_modify_status_user: false,
      status: null,
      customer_id: null,
    };
  },
  mounted() {
    this.getUsersByParams();
  },
  computed: {
    ...mapState("configuration", ["loading", "users"]),
  },
  methods: {
    ...mapActions("configuration", [
      "selectUser",
      "updateUserStatus",
      "getUsersByParams",
    ]),
    updateModifyStatusUser(id, status) {
      console.log("id2: ", id);
      console.log("status2: ", status);
      let data = {
        status: status,
        customer_id: id,
      };
      console.log("data: ", data);
      this.updateUserStatus(data)
        .then((res) => {
          console.log(res);
          this.dialog_modify_status_user = false;
        })
        .catch((err) => {
          console.err(err);
          this.dialog_modify_status_user = false;
        });

      (this.status = null), (this.customer_id = null);
    },
    startUpdate(id, status) {
      if (status === "canceled") status = "ATIVO";
      else status = "canceled";

      console.log("id: ", id);
      (this.status = status), (this.customer_id = id);
      this.dialog_modify_status_user = true;
    },
    openUserForm(type, data) {
      let obj = {
        status: true,
        type: type,
      };
      this.selectUser(data);
      eventBus.$emit("userForm", obj);
    },
  },
};
</script>
